<div
  #advanceButton
  class="ripple-container"
  matRipple
  [class.disabled]="disabled$ | async"
  [matRippleDisabled]="disabled$ | async"
  (click)="onBtnClick(true)"
>
  <mat-icon>
    thumb_up
  </mat-icon>
  Advance
</div>
<div
  #rejectButton
  class="ripple-container"
  matRipple
  [class.disabled]="disabled$ | async"
  [matRippleDisabled]="disabled$ | async"
  (click)="onBtnClick(false)"
>
  <mat-icon>
    thumb_down
  </mat-icon>
  Reject
</div>
